import { Box, Skeleton, Spacer, Stack } from '@chakra-ui/react';

/** One placeholder row, laid out like a real one so the list does not jump when the drafts arrive. */
export const DraftListItemSkeleton = () => (
  <Box px="4" py="3" borderBottomWidth="1px" borderLeftWidth="3px" borderLeftColor="transparent">
    <Stack spacing="2">
      <Stack direction="row" align="center" spacing="2">
        <Skeleton h="3" w="16" />
        <Spacer />
        <Skeleton h="3" w="20" />
      </Stack>
      <Skeleton h="4" w="80%" />
      <Stack direction="row" align="center" spacing="2">
        <Skeleton h="3" flex="1" maxW="52" />
        <Skeleton h="4" w="24" borderRadius="full" />
      </Stack>
    </Stack>
  </Box>
);
